import type { Theme } from '@mui/material';

export const styles = {
  tile: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    px: 1,
    py: 2,
  }),
};
